// /**
//  * Возвращает координаты всех ячеек, занимаемых предметом
//  * @param targetX Координата X ячейки, на которую наведен курсор
//  * @param targetY Координата Y ячейки, на которую наведен курсор
//  * @param itemSize Размеры предмета {width, height}
//  * @param gridWidth Ширина сетки
//  * @param gridHeight Высота сетки
//  * @returns Массив занятых ячеек или null, если предмет не помещается
//  */
// export default function getOccupiedCells(
//   targetX: number,
//   targetY: number,
//   itemSize: { width: number; height: number },
//   gridWidth: number,
//   gridHeight: number,
// ): { x: number; y: number }[] | null {
//   const { width, height } = itemSize;

//   // Определяем стартовую позицию (может быть центрирована или привязана к углу)
//   // Здесь пример с центрированием предмета относительно курсора
//   const startX = Math.max(0, targetX - Math.floor(width / 2));
//   const startY = Math.max(0, targetY - Math.floor(height / 2));

//   // Корректируем позицию, если предмет выходит за границы
//   const adjustedX = Math.min(startX, gridWidth - width);
//   const adjustedY = Math.min(startY, gridHeight - height);

//   // Проверяем, что предмет полностью помещается
//   if (adjustedX < 0 || adjustedY < 0) {
//     return null;
//   }

//   // Генерируем массив занятых ячеек
//   const occupiedCells: { x: number; y: number }[] = [];

//   for (let y = adjustedY; y < adjustedY + height; y += 1) {
//     for (let x = adjustedX; x < adjustedX + width; x += 1) {
//       occupiedCells.push({ x, y });
//     }
//   }

//   return occupiedCells;
// }

/**
 * Возвращает координаты всех ячеек, занимаемых предметом, где targetX и targetY - левый верхний угол
 * @param targetX Координата X левой верхней ячейки предмета
 * @param targetY Координата Y левой верхней ячейки предмета
 * @param itemSize Размеры предмета {width, height}
 * @returns Массив занятых ячеек или null, если предмет не помещается
 */
export default function getOccupiedCells(
  targetX: number,
  targetY: number,
  itemSize: { width: number; height: number },
): { x: number; y: number }[] | null {
  const { width, height } = itemSize;

  const occupiedCells: { x: number; y: number }[] = [];

  for (let y = targetY; y < targetY + height; y += 1) {
    for (let x = targetX; x < targetX + width; x += 1) {
      occupiedCells.push({ x, y });
    }
  }

  return occupiedCells;
}
